export default __webpack_public_path__ + "assets/webgl/picking-14.bdbc10a9.glb";